<template>
  <v-dialog persistent v-model="dialog" width="500" :dark="$root.config.dark">
    <v-card>
      <v-card-title :class="['title', $root.colors.primary, 'white--text']" v-html="lang.errorDialogTitle" />
      <v-card-text v-html="lang.errorDialogText" />
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn :color="$root.colors.primary" @click="toStartPage" :title="lang.toStartPage" v-html="lang.toStartPage" dark />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import lang from '../helpers/lang'
import events from '../helpers/events'
import methods from '../helpers/methods'

export default {
  name: 'ErrorDialog',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      dialog: false
    }
  },
  created () {
    this.$root.$on(events.error, () => {
      this.dialog = true
    })
  },
  methods: {
    /**
     * Close the dialog and navigate to the start page
     * @method toStartPage
     * @return {void}
     */
    toStartPage () {
      this.dialog = false
      this.goToResource()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/error-dialog.vue